
import styled from "styled-components";
import RouteLineForYetkiliBilgi from "../../loadUpdate/sections/shared/others/RouteLineForYetkiliBilgi";
import YetkiliPhoneNumberInput from "../../loadUpdate/sections/yetkiliBilgi/inputs/YetkiliPhoneNumberInput";
import AliciSmsDogrulamaCheckbox from "../../loadUpdate/sections/bosaltma/inputs/aliciBilgileri/AliciSmsDogrulamaCheckbox";
import SmsDogrulamaPhoneNumberInput from "../../loadUpdate/sections/bosaltma/inputs/aliciBilgileri/SmsDogrulamaPhoneNumberInput";
import InputText from "../../shared/input/new/InputText";
import { updateRouteItem } from "../../../features/addLoad/addLoadSlice";
import { useDispatch } from "react-redux";

const Container = styled.div`
  width: 100%;

  color: ${({ theme }) => theme.mainTextColor};

  .route-list {
    display: flex;
    flex-direction: column;
    width: 100%;

    .route-item {
      width: 100%;
      display: flex;

      .form-side {
        display: flex;
        flex-direction: column;
        margin-left: 6px;

        .item-top {
          padding-left: 3px;
          border-bottom: 1px solid ${({ theme }) => theme.mainTextColor};
          padding-bottom: 2px;
          display: flex;
          justify-content: space-between;

          h4 {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
          }

          .delete-btn {
            padding: 4px 14px;
            border-radius: 5px;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            font-size: var(--font-size-sm);
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            cursor: pointer;

            &:hover {
              background-color: ${({ theme }) => theme.mainTextColor};
              color: ${({ theme }) => theme.mainBgColor};
            }
          }
        }

        .input-list {
          display: flex;
          flex-direction: column;
          padding-left: 20px;
          padding-top: 20px;
          gap: 20px;
          margin-bottom: 40px;

          .grp {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .grp-top-aligned {
            display: flex;
            align-items: flex-start;
            gap: 10px;
          }
        }
      }
    }
  }

  .bottom-btn-container {
    width: 100%;
    padding: 50px;
    display: flex;
    justify-content: space-between;

    .icon {
      fill: var(--color-main);
      font-size: 1.6rem;
    }

    span {
      color: ${({ theme }) => theme.mainTextColor};
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
    }
  }
`;

const AddLoadYetkiliBilgiSection = ({ data, setData }) => {
  const dispatch = useDispatch()


  const yuklemeList = data?.filter(item => item.locationType === "yukleme")?.map((item, i) => {
    return {...item, order:i+1, locationType: "yukleme"}
  }) || []

  const bosaltmaList = data?.filter(item => item.locationType === "bosaltma")?.map((item, i) => {
    return {...item, order:i+1, locationType: "bosaltma"}
  }) || []

  const handleChange = ({ id, key, value }) => {
    const updatedData = data.map((item) => {
      if(item.id === id){
        dispatch(updateRouteItem({id: id, [key]: value}))
        return {...item, [key]: value}
      }else{
        return item
      }
    })
    setData(updatedData);
  };

  return (
    <Container>
      <div className="route-list">
        {[...yuklemeList, ...bosaltmaList].map((item, i) => (
          <div className="route-item">
            <RouteLineForYetkiliBilgi type={i === 0 ? "start" : "mid"} isEnd={i+1 === data.length} />
            <div className="form-side">
              <div className="item-top">
                <h4 className="h4">{`${item.order}.${item.locationType} (${item.locationData.location})`}</h4>
              </div>
              <div className="input-list">
                <InputText data={item.companyName} setData={(e) => handleChange({id: item?.id, key: `companyName`, value: e.target.value})} name={`companyName${item.id}`} labelText={item.locationType === "yukleme" ? "Gönderici Adı / Ünvanı" : "Alıcı Adı / Ünvanı"} inputWidth={"100%"} />
                <YetkiliPhoneNumberInput addLoad item={item} keyData={"routePointPersonPhoneNumber"} data={data} setData={setData} name={"yetkiliPhone" +item.id} labelText={"Telefonu"} inputWidth={"100%"} />
                <InputText data={item.mailAddress} setData={(e) => handleChange({id: item?.id, key: `mailAddress`, value: e.target.value})} name={`mailAddress${item.id}`}  labelText={item.locationType === "yukleme" ? "Gönderici Mail Adresi" : "Alıcı Mail Adresi"} inputWidth={"100%"} />
                <InputText data={item.routePointPersonName} setData={(e) => handleChange({id: item?.id, key: "routePointPersonName", value: e.target.value})} name={`routePointPersonName${item.id}`}  labelText={item.locationType === "yukleme" ? "Yükleme Yetkilisi" : "Boşaltma Yetkilisi"} inputWidth={"100%"} />
                {item.locationType === "bosaltma" &&
                  <AliciSmsDogrulamaCheckbox addLoad item={item} data={data} setData={setData} keyData={"smsVerification"} labelText={"Yük Alıcıya SMS Doğrulama Kodu İle Teslim Edilsin"}/>
                }
                {
                  item.smsVerification &&
                  <SmsDogrulamaPhoneNumberInput addLoad item={item} data={data} setData={setData} keyData={"smsVerificationPhoneNumber"} name={"smsVerificationPhoneNumber"} labelText={"Sms doğrulamasının Gönderileceği Telefon"}/>
                }
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default AddLoadYetkiliBilgiSection